/* tslint:disable */
import { Coordinates } from './coordinates';

/**
 */
export class TimeBasedCurve {
    top?: Coordinates;
    int?: Coordinates;
    bot?: Coordinates;
    average?: Coordinates;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/time-based-curve.ts